import React from 'react';
import styled from 'styled-components';
import { TPage } from '../AppLayout';
import powered_by from "../../../../assets/images/OrderswiftLogo2025.png";

type CardProps = {
    children: JSX.Element | JSX.Element[];
    page: TPage;
};

const Content = ({ children, page = null }: CardProps) => {
    return (
        <StyledContainer className="bgContainer" page={page}>
            {children}
            <Background page={page} />
            { page == 'confirmation' && (
                <div className="orderswift-banner">
                    <img width={169} height={15} src={powered_by} alt={'Powered by Orderswift'} />
                </div>
            )}
        </StyledContainer>
    );
};

const Background = styled.div<{ page: TPage }>`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: #ffffff;
`;

const StyledContainer = styled.div<{ page: TPage }>`
    display: block;
    margin: 0 auto;
    position: relative;
    max-width: 100%;
    background-position-y: 48px;
    min-height: 100vh;

    ${(props) => props.page === 'channels' && `
        max-width: none;
        padding: 0;
        margin-top: 0;
        margin-bottom: 0;
        margin-left: 0;
        width: 50%;
        margin-right: 0;
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        background: var(--layouts_body_channel_select_bg);

        @media screen and (max-width: 767px) {
            width: 100%;
            height: auto;
            min-width: 0;
            max-width: none;
        }
    `}

    ${(props) => props.page === 'menu' && `
        max-width: none;
        background: var(--layouts_body_menu_bg);
    `}

    ${(props) => props.page === 'checkout' && `
        background: var(--layouts_body_payment_bg);
    `}

    ${(props) => props.page === 'confirmation' && `
        background: var(--layouts_body_confirmation_bg);
    `}

    ${(props) => props.page === 'order-at-table' && `
        background: var(--layouts_body_dine_in_bg);
    `}

    ${(props) => (props.page === 'checkout' || props.page === 'confirmation') && `
        padding-top: 60px;
        padding-left: 48px;
        padding-right: 48px;

        @media screen and (max-width: 992px){
            padding-left: 0px;
            padding-right: 0px;
        }
    `}

    @media screen and (max-width: 992px) {
        ${(props) => props.page === 'sites' ? `width: auto;` : null}
    }

    .orderswift-banner {
        z-index: 999;
        display: flex;
        justify-content: center;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #FFFFFF;
        border-top: 2px solid #000000;
        padding: 10px 0;
    }
`;

export default Content;
